import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";

interface IProps {
  children: ReactNode;
  title: string;
  subtitle: string;
  path: string;
}

const InterestedCard: React.FC<IProps> = ({
  children,
  title,
  subtitle,
  path,
}) => {
  return (
    <>
      <Box
        boxSizing="border-box"
        display="flex"
        flexDirection="column"
        borderRadius={{ xs: 3.5, md: 5 }}
        justifyContent="center"
        alignItems="center"
        bgcolor="background.default"
        py={{ xs: 7 }}
        px={{ xs: 2, sm: 3 }}
        minHeight={{ xs: 246, md: 402 }}
        mb={{ xs: 2, md: 4 }}
      >
        {children}
      </Box>
      <Typography variant="h4" mb={2}>
        {title}
      </Typography>
      <Typography variant="body1" mb={4} display={{ xs: "none", lg: "block" }}>
        {subtitle}
      </Typography>

      <Button
        component={Link}
        to={path}
        variant="text"
        endIcon={<ArrowRightIcon />}
        sx={{ p: 0 }}
        children="Explore"
      />
    </>
  );
};

export default InterestedCard;
